import { api, apiFetchFormData } from "../utils/api";
import type {
  RestAvailableBillingItem,
} from "@KassaroAB/shared/types/availableBillingItem";
import type { AvailableBillingItemId, StoreId } from "@KassaroAB/shared/types/ids";

export const getAvailableBillingItemsApi = async (): Promise<RestAvailableBillingItem[]> => {
  return api.get(`admin/availableBillingItems`);
};

export const getStoreAvailableBillingItemsApi = async (
  storeId: StoreId,
): Promise<RestAvailableBillingItem[]> => {
  return api.get(`stores/${storeId}/availableBillingItems`);
};

export const getAvailableBillingItemApi = async (
  availableBillingItemId: AvailableBillingItemId,
): Promise<RestAvailableBillingItem> => {
  return api.get(`admin/availableBillingItems/${availableBillingItemId}`);
};

export const createAvailableBillingItemApi = async (
  formData: FormData,
): Promise<RestAvailableBillingItem> => {
  return apiFetchFormData("admin/availableBillingItems", {
    method: "POST",
    body: formData,
  }) as Promise<RestAvailableBillingItem>;
};

export const updateAvailableBillingItemApi = async (
  availableBillingItemId: AvailableBillingItemId,
  formData: FormData,
): Promise<RestAvailableBillingItem> => {
  return apiFetchFormData(`admin/availableBillingItems/${availableBillingItemId}`, {
    method: "PUT",
    body: formData,
  }) as Promise<RestAvailableBillingItem>;
};

export const archiveAvailableBillingItemApi = async (
  availableBillingItemId: AvailableBillingItemId,
): Promise<void> => {
  return api.delete(`admin/availableBillingItems/${availableBillingItemId}`);
};
